import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { appendPassThroughToUrl, extractPassThroughParams } from 'src/connect/passThroughParams'
import { pagesPath } from 'src/routes/$path'
import { LoginNavigationUseHandleLoginNavigationLoginNavigationFragment as LoginNavigation } from './useHandleLoginNavigation.gen'

export const useHandleLoginNavigation = () => {
  const router = useRouter()

  const navigate = useCallback(
    (url: string) => {
      const finalUrl = appendPassThroughToUrl(url, extractPassThroughParams(window.location.search))
      if (finalUrl.startsWith(window.location.origin)) {
        router.push(finalUrl)
      } else {
        window.location.href = finalUrl
      }
    },
    [router],
  )

  return useCallback(
    (navigation?: LoginNavigation | null) => {
      if (navigation) {
        if (navigation.__typename === 'LoginNavigationLoginCompleted') {
          if (navigation.redirectUri) {
            const url = new URL(navigation.redirectUri)
            url.searchParams.set('pharmacy_type', navigation.currentLoginPharmacyType)
            navigate(url.toString())
            return
          }
        }
        if (navigation.__typename === 'LoginNavigationRequireChangeDefaultPassword') {
          if (navigation.redirectTo) {
            navigate(navigation.redirectTo)
            return
          }
          return
        }
      }

      router.push(pagesPath.$404.$url())
    },
    [router, navigate],
  )
}
